import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { ContractOverviewPayrollPolicyFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { periodicityByRecurrence } from 'modules/payroll_bundle/lib/payrollPolicy'

interface Props {
  contractPayrollPolicy: ContractOverviewPayrollPolicyFragment | undefined | null
  canEdit: boolean
}

const PayrollPolicy = ({ contractPayrollPolicy, canEdit }: Props) => {
  const policy = contractPayrollPolicy?.policy
  const title = canEdit
    ? i18n.t('contract_versions.compensation.payroll_policy.editor_title')
    : i18n.t('contract_versions.compensation.payroll_policy.viewer_title')

  const getEditorPolicyLabel = () => {
    if (!policy) {
      return i18n.t('contract_versions.compensation.not_informed')
    }

    const periodicity = periodicityByRecurrence(policy.recurrence)

    return `${policy.name} -> ${periodicity?.label}.`
  }

  const getViewerPolicyLabel = () => {
    if (!policy) {
      return null
    }

    const periodicity = periodicityByRecurrence(policy.recurrence)
    return periodicity?.label
  }

  const getPolicyLabel = () => {
    if (canEdit) return getEditorPolicyLabel()

    return getViewerPolicyLabel()
  }

  return (
    <Box gridColSpan={{ xxs: 12, xs: 6, s: 6 }} gap="s8">
      <Text size="200" weight="normal" color="grey800">
        {title}
      </Text>

      <Text size="300" weight="medium" color="grey1000">
        {getPolicyLabel()}
      </Text>
    </Box>
  )
}

export default observer(PayrollPolicy)
